import axios, { type AxiosRequestConfig, type AxiosResponse } from "axios"

const instance = axios.create({
    responseType: "json",
    timeout: 50000,
})

// 请求拦截
instance.interceptors.request.use((config) => {
    const nuxtConfig = useRuntimeConfig().public
    const site = useNuxtApp().$site
    if (!config.baseURL) {
        config.baseURL = nuxtConfig.api + "apis/"
    }
    if (site.token.value) {
        config.headers["Authorization"] = site.token.value
    }
    return config
})

// 响应拦截
instance.interceptors.response.use(
    (response: AxiosResponse<LyRequest.Response<any>>): any => {
        const { errcode } = response.data
        if (errcode === 0) {
            return Promise.resolve(response.data)
        } else {
            if (errcode > 11000) {
                useNuxtApp().$site.token.value = null
                throw createError({
                    statusCode: 401,
                    statusMessage: "",
                })
            }
            return Promise.reject(response)
        }
    },
    (error) => {
        return Promise.reject(error)
    },
)

export const useAxios = () => {
    return instance
}

export const useGet = <T = any>(
    url: string,
    params?: Record<string, any>,
    config?: Exclude<AxiosRequestConfig, "params">,
) => {
    return instance.get<T, LyRequest.Response<T>>(url, {
        params,
        ...config,
    })
}

export const usePost = <T = any>(
    url: string,
    data?: Record<string, any>,
    params?: Record<string, any>,
    config?: Exclude<AxiosRequestConfig, "params">,
) => {
    return instance.post<T, LyRequest.Response<T>>(url, data, {
        params,
        ...config,
    })
}

export const useDelete = <T = any>(
    url: string,
    data?: Record<string, any>,
    params?: Record<string, any>,
    config?: Exclude<AxiosRequestConfig, "params" | "data">,
) => {
    return instance.delete<T, LyRequest.Response<T>>(url, {
        params,
        data,
        ...config,
    })
}
